import * as React from "react";
import { ChevronDownIcon } from "lucide-react";

import { Button } from "./button";
import { Calendar } from "./calendar";
import { Input } from "./input";
import { Label } from "./label";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

export function DateTimePicker({
  date,
  setDate,
  timeValue,
  setTimeValue,
  placeholder = "Select date and time",
  disabled = false,
  className,
  label,
  showTime = true,
}) {
  const [open, setOpen] = React.useState(false);

  const handleDateSelect = selectedDate => {
    if (selectedDate) {
      setDate(selectedDate);
      setOpen(false);
    }
  };

  const handleTimeChange = e => {
    if (setTimeValue) {
      setTimeValue(e.target.value);
    }
  };

  const formatTimeValue = date => {
    if (!date) return "";
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const getInitialTimeValue = () => {
    if (timeValue) return timeValue;
    if (date) return formatTimeValue(date);
    return "";
  };

  return (
    <div className={`flex gap-4 ${className}`}>
      <div className="flex flex-col gap-3">
        <Label htmlFor="date" className="px-1">
          {label || "Date"}
        </Label>
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button variant="outline" id="date" className="w-full justify-between font-normal" disabled={disabled}>
              {date ? date.toLocaleDateString() : placeholder}
              <ChevronDownIcon />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto overflow-hidden p-0" align="start">
            <Calendar
              mode="single"
              selected={date}
              onSelect={handleDateSelect}
              classNames={{
                caption: "flex justify-center pt-1 relative items-center",
                nav_button_previous: "absolute left-1",
                nav_button_next: "absolute right-1",
              }}
            />
          </PopoverContent>
        </Popover>
      </div>
      {showTime && (
        <div className="flex flex-col gap-3">
          <Label htmlFor="time" className="px-1">
            Time
          </Label>
          <Input
            type="time"
            id="time"
            step="1"
            value={getInitialTimeValue()}
            onChange={handleTimeChange}
            disabled={disabled}
            className="bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
          />
        </div>
      )}
    </div>
  );
}

export function DatePicker({ date, setDate, placeholder = "Select date", disabled = false, className, label }) {
  const [open, setOpen] = React.useState(false);

  const handleDateSelect = selectedDate => {
    if (selectedDate) {
      setDate(selectedDate);
      setOpen(false);
    }
  };

  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      <Label htmlFor="date" className="px-1">
        {label || "Date"}
      </Label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" id="date" className="w-full justify-between font-normal" disabled={disabled}>
            {date ? date.toLocaleDateString() : placeholder}
            <ChevronDownIcon />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto overflow-hidden p-0" align="start">
          <Calendar
            mode="single"
            selected={date}
            onSelect={handleDateSelect}
            classNames={{
              caption: "flex justify-center pt-1 relative items-center",
              nav_button_previous: "absolute left-1",
              nav_button_next: "absolute right-1",
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
